import React, { useContext } from 'react';
import Layout from '../../engine/layout';
import { Typography } from 'antd';
import { AppContext } from '../../App';

const TourneysWrapper = (props) => {
    const app = useContext(AppContext);

    return <Tourneys app={app} {...props} />;
}

class Tourneys extends Layout {
    constructor(props) {
        super(props);
        this.app = props.app;
    }

    componentDidMount() {
        this.app = this.props.app;
    }

    componentDidUpdate() {
        this.app = this.props.app;
    }

    content (layout = `desktop`) {
        if (layout === `desktop`) {
            return this.contentWide();
        }

        return this.contentMobile();
    }

    head() {
        return (
            <div style={{
                position: `absolute`,
                height: `max(25vh, 300px)`,
                top: 0,
                left: 0,
                right: 0,
            }}>
                <Typography.Title
                    level={2}
                    style={{
                        color: `#F3DD8E`,
                        fontSize: 36,
                        margin: `4vh 0 30px 0`,
                        textAlign: `center`
                    }}
                >
                    Turnīru saraksts
                </Typography.Title>
            </div>
        );
    }

    contentMobile() {
        return (
            <>
                <div style={{ height: 50, width: `100%` }} />
                ..
            </>
        );
    }

    contentWide() {
        return (
            <>
                <Typography.Title level={2}>Turnīru saraksts</Typography.Title>
                ..
            </>
        );
    }
}

export default TourneysWrapper;
